module.exports = __webpack_public_path__ + "static/media/home-tower__narrow.2066732d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-tower__narrow.jpg
// module id = 405
// module chunks = 0